import { Link } from "react-router-dom";
import SubmitForm from "@/pages/about/components/SubmitForm";
import { SITE_EMAIL } from "@/utils/format";

const channels = [
  {
    icon: "ri-mail-send-line",
    title: "爆料与线索",
    value: SITE_EMAIL,
    desc: "附上大致时间和可公开求证的信息来源，处理会更快。",
    href: `mailto:${SITE_EMAIL}`,
    external: true,
  },
  {
    icon: "ri-chat-forward-line",
    title: "内容纠错",
    value: "主题请以【纠错】开头",
    desc: "发现信息有误或有新进展，欢迎随时告诉我们。",
    href: "/about#submit",
    external: false,
  },
  {
    icon: "ri-lightbulb-line",
    title: "合作与建议",
    value: SITE_EMAIL,
    desc: "内容共建、栏目建议或体验反馈，都可以直接来信。",
    href: `mailto:${SITE_EMAIL}`,
    external: true,
  },
];

export default function ContactSection() {
  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-100 border-t border-background-200">
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 md:gap-10">
        <div className="lg:col-span-2">
          <span className="inline-flex items-center gap-1.5 text-xs text-primary-600 bg-primary-50 border border-primary-100 px-2.5 py-1 rounded-full mb-3">
            <i className="ri-customer-service-2-line" aria-hidden="true"></i>
            联系我们
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 tracking-tight">
            有个瓜想告诉我们？
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 leading-relaxed">
            我们通常在收到后一个工作日内回复。投稿可以不留下真实姓名，
            除邮箱外不会收集任何身份信息，来源也不会被公开。
          </p>

          <div className="mt-6 flex flex-col gap-3">
            {channels.map((item) => (
              <div
                key={item.title}
                className="flex items-start gap-3 rounded-lg bg-background-50 border border-background-200 p-4"
              >
                <span className="w-10 h-10 shrink-0 rounded-md bg-primary-50 text-primary-600 flex items-center justify-center">
                  <i className={`${item.icon} text-lg`} aria-hidden="true"></i>
                </span>
                <div className="min-w-0">
                  <p className="text-sm font-medium text-foreground-900">
                    {item.title}
                  </p>
                  {item.external ? (
                    <a
                      href={item.href}
                      rel="nofollow"
                      className="block mt-1 text-xs md:text-sm text-primary-600 hover:text-primary-700 transition-colors break-all cursor-pointer"
                    >
                      {item.value}
                    </a>
                  ) : (
                    <Link
                      to={item.href}
                      className="block mt-1 text-xs md:text-sm text-primary-600 hover:text-primary-700 transition-colors break-all cursor-pointer"
                    >
                      {item.value}
                    </Link>
                  )}
                  <p className="mt-1.5 text-xs text-foreground-400 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-3">
          <SubmitForm />
        </div>
      </div>
    </section>
  );
}